module.exports = __webpack_public_path__ + "static/media/bolso (10).99a99e34.jpg";